// extracted by mini-css-extract-plugin
export default {"container":"Indicator_container__vcyE1","blink":"Indicator_blink__w38wT","icon":"Indicator_icon__EA7dp"};